import { render, staticRenderFns } from "./HuliContactPage.vue?vue&type=template&id=44aa44ea"
import script from "./HuliContactPage.vue?vue&type=script&lang=js"
export * from "./HuliContactPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports